/**
 * アイコン掲載順更新
 *
 * @export UpdateCwsIconPublishOrderVo
 * @class UpdateCwsIconPublishOrderVo
 */
export class UpdateCwsIconPublishOrderVo {
    constructor(
        public iconCode: string,
        public publishOrder: string,
    ) {}
}
